<template>
  <div class="layout" ref="menuLeft">
    <img class="ip_logo" src="@/assets/images/login/ip_logo.png" alt="logo" @click="toHomePage" />
    <div class="menu" v-if="menu">
      <ComplianceBrainMenu />
      <MenuGroup v-for="([key, group]) in Object.entries(menu)" :key="key" :group="group" />
    </div>
  </div>
</template>
<script>
import '@/assets/style/common.less';
import { menu } from '../../menu';
import { getInfo1 } from '@/api/user/userModule';
import MenuGroup from './MenuGroup.vue';
import ComplianceBrainMenu from './ComplianceBrainMenu.vue';
import { clearCJTSupportWidgetCustomerVerification, confirmCJTSupportWidgetCustomer } from '@/utils/cjtSupportWidget';
export default {
  components: {
    MenuGroup,
    ComplianceBrainMenu,
  },
  data() {
    return {
      menu,
    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
  },
  methods: {
    toHomePage() {
      window.location.href = this.homePageUrl;
    },
    goWork() {
      this.$router.push({ path: '/work' });
    },
    getUserInfo() {
      getInfo1()
        .then(
          (res) => {
            if (res.code === 0) {
              localStorage.setItem('objInfo', JSON.stringify(res.data));
              confirmCJTSupportWidgetCustomer();
              this.userInfo = res.data;
            } else {
              clearCJTSupportWidgetCustomerVerification();
              this.$Message.error(res.message);
            }
          },
          (err) => {
            clearCJTSupportWidgetCustomerVerification();
            this.$Message.error(err.message);
          }
        )
        .finally(() => { });
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('objInfo'));
    if (!this.userInfo.userMobile) {
      this.getUserInfo();
    }
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.layout {
  width: 196px;
  background: #f3f8ff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  z-index: 1004;
  border: 1px solid #FFF;
  background: rgba(255, 255, 255, 0.58);
  backdrop-filter: blur(2px);
}

.ip_logo {
  width: 135px;
  margin: 30px auto 20px;
  display: block;
  cursor: pointer;
}

.menu {
  font-size: 16px;
  color: #787B7F;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/menuLeft.vue